import { get } from "lodash";
import React from "react";
import {
  DISTRIBUTION_WITHDRAWAL_MODE,
  getFullName,
  getTaxesAndFeeForWithdrawalTransaction,
  getValues,
} from "../../containers/Distribution/WithdrawalRequestContainer/DistributionConstantsAndFunctions";
import { OPTIONS_DATA_MAPPER } from "../../utils";
import AddToolTip from "../AddToolTip";

const RequestSummaryCard = ({
  values,
  fields,
  employeeData,
  beneficiaries,
  sourceBalances,
}) => {
  const mappingFunction = (_) => {
    const beneficiaryName = beneficiaries?.find((b) => b.id === _.beneficiaryId)
      ?.name;
    return {
      distributionMode: _.distributionMode,
      distributionModeLabel:
        OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES[_.distributionMode],
      taxesAndFees: _.taxesAndFees,
      // getTaxesAndFeeForWithdrawalTransaction(
      //   _,
      //   values,
      //   sourceBalances
      // ),
      allocation: [
        {
          name:
            _.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.self
              ? getFullName(employeeData)
              : _.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
              ? beneficiaryName
              : _[fields.trusteeName],
          requestedAmount: _[fields.requestedAmount],
        },
      ],
    };
  };
  const withdrawalTransactions = get(
    values,
    fields.withdrawalTransactions,
    []
  ).map(mappingFunction);
  let beneficiaryWithdrawalTransactions = {
    distributionMode: DISTRIBUTION_WITHDRAWAL_MODE.beneficiary,
    distributionModeLabel:
      OPTIONS_DATA_MAPPER.DISTRIBUTION_MODES[
        DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
      ],
    taxesAndFees: 0,
    allocation: [],
  };
  withdrawalTransactions
    .filter(
      (_) =>
        _[fields.distributionMode] === DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
    )
    .forEach((element) => {
      beneficiaryWithdrawalTransactions = {
        ...beneficiaryWithdrawalTransactions,
        taxesAndFees:
          beneficiaryWithdrawalTransactions.taxesAndFees + element.taxesAndFees,
        allocation: [
          ...beneficiaryWithdrawalTransactions.allocation,
          ...element.allocation,
        ],
      };
    });
  beneficiaryWithdrawalTransactions =
    beneficiaryWithdrawalTransactions.allocation.length > 0
      ? [beneficiaryWithdrawalTransactions]
      : [];
  const selfWithdrawalTransactions = withdrawalTransactions.filter(
    (_) => _[fields.distributionMode] === DISTRIBUTION_WITHDRAWAL_MODE.self
  );
  const otherWithdrawalTransactions = withdrawalTransactions.filter((_) =>
    [
      DISTRIBUTION_WITHDRAWAL_MODE.traditional_IRA,
      DISTRIBUTION_WITHDRAWAL_MODE.roth_IRA,
      DISTRIBUTION_WITHDRAWAL_MODE.employer_Sponsored,
    ].includes(_[fields.distributionMode])
  );

  let sourceAllocationDisplayData = {};

  return (
    <>
      {[
        ...selfWithdrawalTransactions,
        ...beneficiaryWithdrawalTransactions,
        ...otherWithdrawalTransactions,
      ].map((item, index) => {
        return (
          <div className="summaryCard_layout">
            <div className="d-flex flex-column mt-2">
              {
                <>
                  <div className="d-flex">
                    <div className="summaryCard_Header">
                      {item.distributionModeLabel}
                    </div>
                    <div
                      className="summaryCard_Header"
                      style={{ marginLeft: "auto", marginRight: " 5px" }}
                    >
                      {getValues(
                        item.allocation.reduce(
                          (a, b) => a + b.requestedAmount,
                          0
                        )
                      ).toFixed(2)}
                    </div>
                  </div>
                  {/* ) : (
                  <div>
                    <div className="summaryCard_Header">{withDrawalName}</div>
                    <div className="summaryCard_Body">
                      {item.SourceAllocation}
                    </div>
                  </div>
                )} */}

                  <div className="summaryCard_Line"></div>
                  {item.allocation.map((val, i) => {
                    {
                      console.log("ioppp", val.name);
                    }
                    return (
                      <div className="d-flex">
                        {val.name.length > 25 ? (
                          <div
                            className="summaryCard_Body"
                            style={{ marginTop: "5px" }}
                          >
                            <AddToolTip name={val.name}>
                              {(val.name || "").slice(0, 25)}...
                            </AddToolTip>
                          </div>
                        ) : (
                          val.name
                        )}
                        <div className="summaryCard_BodyAmount">
                          $ {getValues(val[fields.requestedAmount]).toFixed(2)}
                        </div>
                      </div>
                    );
                  })}
                </>
                // :
                // (
                //   <div>
                //     <div className="summaryCard_Header">{withDrawalName}</div>
                //     {Object.keys(item.Details).map((val, i) => {
                //       return (
                //         <div className="d-flex">
                //           <div className="summaryCard_Body">{val}</div>
                //           <div
                //             className="summaryCard_Header"
                //             style={{ marginLeft: "auto", marginRight: " 5px" }}
                //           >
                //             $ {item.Details[val]}
                //           </div>
                //         </div>
                //       );
                //     })}
                //   </div>
                // )
              }

              <div className="summaryCard_Line"></div>
              <div className="d-flex">
                <div className="summaryCard_Body" style={{ marginTop: "5px" }}>
                  Tax & Fees
                </div>
                <div className="summaryCard_BodyAmount">
                  $ {item.taxesAndFees?.toFixed(2)}
                </div>
              </div>

              {/* {withDrawalName !== "Source Allocation" ? (
              <div className="d-flex">
                  Tax & Fees
                </div>
                <div className="summaryCard_BodyAmount">$ {item.Fee}</div>
              </div>
            ) : (

              <div className="d-flex">
                <div
                  className="summaryCard_Header"
                  style={{ marginTop: "5px" }}
                >
                  Net Withdrawal
                </div>
                <div
                  className="summaryCard_Header"
                  style={{
                    marginLeft: "auto",
                    marginRight: "5px",
                    marginTop: "5px",
                  }}
                >
                  $ {item.netWithdrawalFee}
                </div>
              </div>
              
            )} */}
            </div>
          </div>
        );
      })}
      {/* this is for source allocation */}
      {/* <>
        <div className="summaryCard_layout">
          <div className="d-flex flex-column mt-2">
            <div className="d-flex">
              <div className="summaryCard_Header">{item.distributionModeLabel}</div>
              <div
                className="summaryCard_Header"
                style={{ marginLeft: "auto", marginRight: " 5px" }}
              >
                {item.allocation.reduce((a, b) => a + b.requestedAmount, 0)}
              </div>
            </div>
            <div className="summaryCard_Line"></div>
            {item.allocation.map((val, i) => {
              return (
                <div className="d-flex">
                  <div
                    className="summaryCard_Body"
                    style={{ marginTop: "5px" }}
                  >
                    {val.name}
                  </div>
                  <div className="summaryCard_BodyAmount">
                    $ {val[fields.requestedAmount]}
                  </div>
                </div>
              );
            })}

            <div className="d-flex">
              <div
                className="summaryCard_Header"
                style={{ marginTop: "5px" }}
              >
                Net Withdrawal
              </div>
              <div
                className="summaryCard_Header"
                style={{
                  marginLeft: "auto",
                  marginRight: "5px",
                  marginTop: "5px",
                }}
              >
                $ {item.netWithdrawalFee}
              </div>
            </div>
          </div>
        </div>
      </> */}
    </>
  );
};

export default RequestSummaryCard;
